import React, { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Loader2 } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_dfd40c82-155c-446f-b6a2-3614c96b8638/artifacts/l43p30e7_Frame%20%283%29%20%282%29.png";

const AdminLogin = () => {
  const { user, loading, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Loading…</div>;
  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) navigate("/admin");
    else setErr(res.error);
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white border border-zinc-200 rounded-2xl p-10 shadow-sm" data-testid="admin-login-card">
        <Link to="/" className="flex items-center gap-3 mb-8">
          <img src={LOGO} alt="logo" className="h-10 w-auto bg-white rounded" />
          <span className="font-display text-xl font-black tracking-tight">
            Reptile<span className="text-orange-500">Global</span>
          </span>
        </Link>
        <h1 className="font-display text-3xl font-black tracking-tight text-zinc-950">Admin Portal</h1>
        <p className="text-sm text-zinc-500 mt-1">Sign in to manage content.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="block text-xs font-bold uppercase tracking-widest text-zinc-500 mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-login-email"
              className="w-full px-4 py-3 border border-zinc-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-orange-500"
            />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-widest text-zinc-500 mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-login-password"
              className="w-full px-4 py-3 border border-zinc-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-orange-500"
            />
          </div>
          {err && <div className="text-red-600 text-sm font-semibold" data-testid="admin-login-error">{err}</div>}
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded-full inline-flex items-center justify-center gap-2 disabled:opacity-50 transition-colors"
          >
            {submitting && <Loader2 size={16} className="animate-spin" />}
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
